export default __webpack_public_path__ + "static/media/photo--lg--115.dd3585e4.jpg";